import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Business } from '../models/business.model';
import { EditBusinessHoursComponent } from '../../business/edit-business-hours/edit-business-hours.component';
import { CivilianTimePipe } from '../../shared/civilian-time/civilian-time.pipe';
import { hasTag } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var HoursComponent = /** @class */ (function () {
    function HoursComponent(_toggleService, _editHoursDialog, snackBar, _businessService) {
        var _this = this;
        this._toggleService = _toggleService;
        this._editHoursDialog = _editHoursDialog;
        this.snackBar = snackBar;
        this._businessService = _businessService;
        this.isRegionalManager = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    HoursComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._businessService.isRegionalManager()];
                    case 1:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_c.sent());
                        _c.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    HoursComponent.prototype.formatHour = function (hour) {
        return new CivilianTimePipe().transform(hour);
    };
    /*
     * If a business has an hours tag, it should be mutually exclusive, that is to say,
     * Hours::24/7 should not exist in conjunction with Hours::Irregular and Hours::By Appointment.
     * Only one such tag should exist for any given business, and if a tag exists, then we should
     * ignore this business.hours (BusinessHours table in the db). Otherwise, if no 'hours' tag exists then we will
     * display the information from business.hours
     */
    HoursComponent.prototype.formatHoursTags = function () {
        var hours = '';
        if (hasTag(this.business.tags, 'Hours::24/7')) {
            hours += '24 hours a day, 7 days a week';
        }
        else if (hasTag(this.business.tags, 'Hours::Irregular')) {
            hours += 'Irregular';
        }
        else if (hasTag(this.business.tags, 'Hours::By Appointment')) {
            hours += 'By Appointment';
        }
        else if (this.business.hours.length === 1) {
            if (!(this.business.hours[0].fromMmDd === '01/01' && this.business.hours[0].toMmDd === '12/31')) {
                hours += 'From ' + this.business.hours[0].fromMmDd + ' to ' + this.business.hours[0].toMmDd + ': ';
            }
            hours += this.business.hours[0].fromWeekDay + ' - ' + this.business.hours[0].toWeekDay + ', ' +
                this.formatHour(this.business.hours[0].fromTime) + ' to ' + this.formatHour(this.business.hours[0].toTime);
        }
        return hours;
    };
    HoursComponent.prototype.openEditHoursDialog = function () {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        var dialogConfig = {
            disableClose: true,
            autoFocus: true,
            width: '95%',
            data: {
                title: 'Hours',
                business: this.business
            }
        };
        var dialogRef = this._editHoursDialog.open(EditBusinessHoursComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (!isSuccess) {
                _this.snackBar.open(ERROR_MSG, 'Error', { duration: 6000 });
            }
        });
    };
    Object.defineProperty(HoursComponent.prototype, "hasContent", {
        get: function () {
            return this.hasHoursTag() ||
                !this.isBusinessHoursNullEmptyOrUndefined() ||
                !this.isClosedHolidaysNullEmptyOrUndefined();
        },
        enumerable: true,
        configurable: true
    });
    HoursComponent.prototype.hasHoursTag = function () {
        return this.business.tags.some(function (bTag) { return /^Hours::.+/.test(bTag.tagName); });
    };
    HoursComponent.prototype.isBusinessHoursNullEmptyOrUndefined = function () {
        return !this.business.hours;
    };
    HoursComponent.prototype.isClosedHolidaysNullEmptyOrUndefined = function () {
        return !this.business.hoursExceptions;
    };
    return HoursComponent;
}());
export { HoursComponent };
